export default {"src":"/_next/static/media/ARB.a4794491.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};